/**
 * SNCKD. — Signature-Box AJAX Add-to-Cart
 * Die Signature-Box nutzt ein eigenes Formular (Box-Builder). Standardmäßig
 * würde es per Vollreload auf /cart springen. Hier fangen wir das ab, fügen
 * per AJAX hinzu und feuern Horizons 'cart:update'-Event – damit öffnet der
 * Warenkorb-Drawer (auto-open) und lädt seinen Inhalt selbst nach, genau wie
 * bei den normalen Boxen. Man kann also weiterstöbern.
 */
(function () {
  'use strict';

  function showError(form, msg) {
    var el = form.querySelector('[data-snckd-cart-error]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-snckd-cart-error', '');
      el.style.cssText = 'color:#ff6b6b;font-size:13px;margin-top:12px;font-family:Inter,sans-serif;';
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  function clearError(form) {
    var el = form.querySelector('[data-snckd-cart-error]');
    if (el) el.textContent = '';
  }

  async function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    clearError(form);

    var btn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);

    var wasDisabled = btn ? btn.disabled : false;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }

    try {
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!addRes.ok) {
        var msg = 'Hinzufügen fehlgeschlagen. Bitte versuche es erneut.';
        try {
          var errJson = await addRes.json();
          if (errJson && errJson.description) msg = errJson.description;
        } catch (e2) {}
        showError(form, msg);
        return;
      }

      // Warenkorb für item_count holen
      var cart = {};
      try {
        cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      } catch (e3) {}

      // Horizon-Event: Drawer öffnet (auto-open) + cart-items lädt sich selbst nach
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: form.id || 'snckd-signature-box',
            data: {},
          },
        })
      );
    } catch (err) {
      showError(form, 'Verbindung fehlgeschlagen. Bitte versuche es erneut.');
    } finally {
      if (btn) {
        btn.disabled = wasDisabled;
        btn.classList.remove('is-loading');
      }
    }
  }

  function init() {
    document.querySelectorAll('form.snckd-product__form').forEach(function (form) {
      if (form.dataset.snckdAjaxBound) return;
      form.dataset.snckdAjaxBound = '1';
      form.addEventListener('submit', onSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
